interface IOnboardingValidation {
  [key: string]: {
    fields: string[];
    toastMessage: {
      title: string;
      description: string;
      variant: string;
    };
    finalStep?: boolean;
  };
}

export const steps: IOnboardingValidation = {
  0: {
    fields: ["first_name", "last_name", "phone_number"],
    toastMessage: {
      title: "Informações faltando",
      description: "Por favor, preencha os campos para continuar.",
      variant: "destructive",
    },
  },
  1: {
    fields: ["current_occupation"],
    toastMessage: {
      title: "Nenhuma opção selecionada",
      description: "Por favor, selecione uma opção para continuar.",
      variant: "destructive",
    },
  },
  2: {
    fields: ["expected_app_benefit"],
    toastMessage: {
      title: "Nenhuma opção selecionada",
      description: "Por favor, selecione uma opção para continuar.",
      variant: "destructive",
    },
  },
  3: {
    fields: ["preferred_initial_focus"],
    toastMessage: {
      title: "Nenhuma opção selecionada",
      description: "Por favor, selecione uma opção para continuar.",
      variant: "destructive",
    },
    finalStep: true,
  },
};
